import { useRef, useState } from "react";
import { Crosshair, Loader2, X } from "lucide-react";

// Draw a box around the object to follow, then run the tracker (progress shown while it works).
export const TrackOverlay = ({ busy = false, progress = 0, onStart, onCancel }) => {
  const ref = useRef(null);
  const [box, setBox] = useState(null);
  const down = (e) => {
    if (busy) return;
    const r = ref.current.getBoundingClientRect();
    const x0 = (e.clientX - r.left) / r.width, y0 = (e.clientY - r.top) / r.height;
    const move = (ev) => {
      const x1 = Math.max(0, Math.min(1, (ev.clientX - r.left) / r.width)), y1 = Math.max(0, Math.min(1, (ev.clientY - r.top) / r.height));
      setBox({ x: Math.min(x0, x1), y: Math.min(y0, y1), w: Math.abs(x1 - x0), h: Math.abs(y1 - y0) });
    };
    const up = () => { window.removeEventListener("pointermove", move); window.removeEventListener("pointerup", up); };
    window.addEventListener("pointermove", move); window.addEventListener("pointerup", up);
  };
  const ok = box && box.w > 0.02 && box.h > 0.02;
  return (
    <div ref={ref} onPointerDown={down} className="absolute inset-0 z-20 cursor-crosshair bg-black/25" data-testid="track-overlay">
      {box && <div className="pointer-events-none absolute border-2 border-[#FFC94D] bg-[#FFC94D]/10" data-testid="track-box"
        style={{ left: `${box.x * 100}%`, top: `${box.y * 100}%`, width: `${box.w * 100}%`, height: `${box.h * 100}%` }} />}
      <div className="absolute left-1/2 top-3 flex -translate-x-1/2 items-center gap-2 rounded-full bg-[#121216]/95 px-3 py-1.5 text-xs text-white shadow-lg" onPointerDown={(e) => e.stopPropagation()}>
        {busy ? <><Loader2 size={13} className="animate-spin text-[#FFC94D]" /> Tracking… {Math.round(progress * 100)}%</>
          : <><Crosshair size={13} className="text-[#FFC94D]" /> {ok ? "Ready to track" : "Drag a box around the object"}</>}
        {!busy && <button onClick={() => onStart(box)} disabled={!ok} data-testid="track-start-btn" className="rounded-full bg-[#FFC94D] px-3 py-0.5 font-bold text-black disabled:opacity-40">Track</button>}
        <button onClick={onCancel} data-testid="track-cancel-btn" className="rounded-full p-0.5 text-[#A1A1AA] hover:text-white"><X size={13} /></button>
      </div>
    </div>
  );
};
